import React from 'react';
import styled from 'styled-components';

import Tag from 'antd/es/tag';

const statusStyles = {
  active: {
    color: '#52C41A',
    background: '#F6FFED',
    border: '1px solid #B7EB8F',
  },
  inactive: {
    color: '#828C94',
    background: '#FAFBFC',
    border: '1px solid #EFF2F5',
  },
}

const StyledTag = styled(Tag)`
  box-sizing: border-box;
  border-radius: 4px;
`;

const Status = ({ isActive, activeText = 'Active', inactiveText = 'Disabled', ...rest }) => {
  return (
    <StyledTag style={isActive ? statusStyles.active : statusStyles.inactive} {...rest}>
      {isActive ? activeText : inactiveText}
    </StyledTag>
  );
};

export default Status;
